module.exports = __webpack_public_path__ + "static/youtube-1264f10c864d67e86258e40318aac407.jpg";